module.exports = __webpack_public_path__ + "static/media/No_Viewed_Stories.a4102898.svg";